import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-480ddf78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FeedbacksListItem" }
const _hoisted_2 = { class: "FeedbacksListItem__header" }
const _hoisted_3 = { class: "header__text" }
const _hoisted_4 = { class: "text__username" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "на позицию", -1))
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "FeedbacksListItem__container mt-2" }
const _hoisted_8 = { class: "container__selectable" }
const _hoisted_9 = { class: "container__selectable" }
const _hoisted_10 = { class: "FeedbacksListItem__actions" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye mr-2" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-restore mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.item.name), 1),
        _hoisted_5,
        _createVNode(_component_router_link, {
          class: "text__vacancy",
          target: "_blank",
          to: `/vacancies/vacancy/${_ctx.item.vacancy_id}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.item.vacancy_name), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_cheap, {
          class: _normalizeClass(["small mr-3", { primary: Boolean(_ctx.item.path) }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.item.path ? 'С резюме' : 'Без резюме'), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_cheap, {
          class: _normalizeClass(["small", {
                        green: _ctx.item.status_code === _ctx.FeedbackStatusesT.VIEWED,
                        yellow: _ctx.item.status_code === _ctx.FeedbackStatusesT.BETHINKED,
                        red: _ctx.item.status_code === _ctx.FeedbackStatusesT.CANCELED,
                    }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.item.status_name), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", null, [
        _createTextVNode(" Телефон: "),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.item.phone), 1)
      ]),
      _createElementVNode("p", null, [
        _createTextVNode(" Email: "),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.item.email), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_the_button, {
          class: "text small primary",
          onClick: _ctx.emitChangeStatus
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createTextVNode(" Изменить статус ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.item.path)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.item.path,
              target: "_blank",
              class: "mr-3"
            }, [
              _createVNode(_component_the_button, { class: "small text primary" }, {
                default: _withCtx(() => [
                  _hoisted_15,
                  _createTextVNode(" Посмотреть резюме ")
                ]),
                _: 1
              })
            ], 8, _hoisted_14))
          : _createCommentVNode("", true),
        (!_ctx.item.is_archive)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 1,
              class: "small text red",
              loading: _ctx.state.is_archive_loading,
              onClick: _ctx.archiveFeedback
            }, {
              default: _withCtx(() => [
                _hoisted_16,
                _createTextVNode(" В архив ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.item.is_archive)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 2,
              class: "small text green",
              loading: _ctx.state.is_archive_loading,
              onClick: _ctx.unarchiveFeedback
            }, {
              default: _withCtx(() => [
                _hoisted_17,
                _createTextVNode(" Восстановить из архива ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}